import React from "react";
import { Outlet } from "react-router-dom";

import Alert from "./Alert";
import Footer from "./Footer";
import Header from "./Header";
import PageHeader from "./PageHeader";
import TopBar from "./TopBar";

const Layout = (): React.JSX.Element => {
    return (
        <div id="appRoot" data-testid="appRoot">
            <TopBar />
            <Header />
            <main>
                <PageHeader />
                <Alert />
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
